// actions/healthcareSectionActions.js
import { toast } from "react-toastify";
import * as api from "../api";
import {
  START_LOADING,
  END_LOADING,
  CREATE_SECTION_HEALTHCARE,
  GET_SECTIONS_HEALTHCARE,
  UPDATE_SECTION_HEALTHCARE,
  DELETE_SECTION_REQUEST_HEALTHCARE,
  DELETE_SECTION_SUCCESS_HEALTHCARE,
  DELETE_SECTION_FAILURE_HEALTHCARE,
  GET_HEALTHCARE_VENDORS,
} from "../constants/actionTypes.js";

// Create Section
export const createHealthcareSection =
  (sectionData, userId) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.apiCreateHealthcareSection(
        sectionData,
        userId
      );
      dispatch({ type: CREATE_SECTION_HEALTHCARE, payload: data.data });
      dispatch({ type: END_LOADING });
      toast.success(data.message);
    } catch (error) {
      console.log(error.response?.data?.message || error.message);
      toast.error(error.response?.data?.message || error.message);
      dispatch({ type: END_LOADING });
    }
  };

// Fetch Healthcare Sections
export const fetchHealthcareSections =
  (vendorId) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.apiFetchHealthcareSections(vendorId);
      dispatch({ type: GET_SECTIONS_HEALTHCARE, payload: data });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.error("Error fetching sections:", error);
      toast.error(
        "Failed to fetch sections: " +
          (error.response?.data?.message || error.message)
      );
      dispatch({ type: END_LOADING });
    }
  };

// Update Section
export const updateHealthcareSection =
  (sectionId, updatedSectionData) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.apiUpdateHealthcareSection(
        sectionId,
        updatedSectionData
      );
      dispatch({ type: UPDATE_SECTION_HEALTHCARE, payload: data.data });
      dispatch({ type: END_LOADING });
      toast.success("Section updated successfully!");
    } catch (error) {
      console.error("Error updating section:", error);
      toast.error(
        "Failed to update section: " +
          (error.response?.data?.message || error.message)
      );
      dispatch({ type: END_LOADING });
    }
  };

// Delete Section
export const deleteHealthcareSectionRequest = () => ({
  type: DELETE_SECTION_REQUEST_HEALTHCARE,
});

export const deleteHealthcareSectionSuccess = (sectionId, message) => {
  toast.success(message);
  return {
    type: DELETE_SECTION_SUCCESS_HEALTHCARE,
    payload: sectionId,
  };
};

export const deleteHealthcareSectionFailure = (error) => ({
  type: DELETE_SECTION_FAILURE_HEALTHCARE,
  payload: error,
});

export const deleteHealthcareSection =
  (vendorId, sectionId) => async (dispatch) => {
    dispatch(deleteHealthcareSectionRequest());
    try {
      const { data } = await api.apiDeleteHealthcareSection(sectionId);
      dispatch(deleteHealthcareSectionSuccess(sectionId, data.message));
      dispatch(fetchHealthcareSections(vendorId));
    } catch (error) {
      dispatch(deleteHealthcareSectionFailure(error.message));
    }
  };

// Fetch Healthcare Vendors
export const fetchHealthcareVendors =
  (vendorId, isSuperAdmin) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.apiFetchHealthcareVendors(
        vendorId,
        isSuperAdmin
      );
      dispatch({
        type: GET_HEALTHCARE_VENDORS,
        payload: data.healthcareVendors,
      });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.error("Error fetching healthcare vendors:", error);
      toast.error(
        "Failed to fetch healthcare vendors: " +
          (error.response?.data?.message || error.message)
      );
      dispatch({ type: END_LOADING });
    }
  };






